import { render, staticRenderFns } from "./AccountSettingsModal.vue?vue&type=template&id=674b1ba4&scoped=true"
import script from "./AccountSettingsModal.vue?vue&type=script&lang=js"
export * from "./AccountSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingsModal.vue?vue&type=style&index=0&id=674b1ba4&prod&scoped=true&lang=css"
import style1 from "./AccountSettingsModal.vue?vue&type=style&index=1&id=674b1ba4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674b1ba4",
  null
  
)

export default component.exports